import { CONST } from "../CONST";
import { MinigameScene } from "./generic/MinigameScene";

export class TalkScene extends MinigameScene {
    //values
    private timeToReachMaxSpeed = 7000;
    private maxSpeed = 426.5;
    private noteScrollOffset = 70;
    private maxAllowedNoteMisses = 1;

    private notePositions = [
        {x: 490, y: 281, key: CONST.TALK.NOTE_4},
        {x: 638, y: 124, key: CONST.TALK.NOTE_3},
        {x: 799, y: 285, key: CONST.TALK.NOTE_2},
        {x: 968, y: 127, key: CONST.TALK.NOTE_1},
        {x: 1274, y: 265, key: CONST.TALK.NOTE_4},
        {x: 1137, y: 190, key: CONST.TALK.NOTE_2},
        {x: 1660, y: 117, key: CONST.TALK.NOTE_3},
        {x: 1777, y: 256, key: CONST.TALK.NOTE_2},
        {x: 1914, y: 189, key: CONST.TALK.NOTE_4},
        {x: 2135, y: 112, key: CONST.TALK.NOTE_3},
        {x: 2318, y: 283, key: CONST.TALK.NOTE_1},
        {x: 2463, y: 148, key: CONST.TALK.NOTE_2},
        {x: 2608, y: 283, key: CONST.TALK.NOTE_3},
        {x: 2901, y: 143, key: CONST.TALK.NOTE_4},
        {x: 3099, y: 265, key: CONST.TALK.NOTE_3},
        {x: 3326, y: 139, key: CONST.TALK.NOTE_1},
        {x: 3563, y: 281, key: CONST.TALK.NOTE_4},
        {x: 3751, y: 287, key: CONST.TALK.NOTE_3},
        {x: 3929, y: 284, key: CONST.TALK.NOTE_1},
        {x: 4181, y: 209, key: CONST.TALK.NOTE_4},
        {x: 4426, y: 130, key: CONST.TALK.NOTE_3},
        {x: 4657, y: 215, key: CONST.TALK.NOTE_2},
        {x: 4851, y: 293, key: CONST.TALK.NOTE_1},
        {x: 5024, y: 187, key: CONST.TALK.NOTE_3},
        {x: 5254, y: 284, key: CONST.TALK.NOTE_3},
        {x: 5425, y: 91, key: CONST.TALK.NOTE_2},
        {x: 5609, y: 95, key: CONST.TALK.NOTE_1},
    ]

    //logic vars
    private timer = 0;
    private speed = 0;
    private notes : Phaser.GameObjects.Image[] = [];
    private audio !: Phaser.Sound.BaseSound;
    private reachedEnd = false;
    private missedNoteCount = 0;


    constructor(){
        super ({
            sceneName: CONST.SCENES.TALK,
            duration: 17000,
            startScreenColor: 0xC1FFFF,
            startText: "TALK!",
            startTextColor: 0x323232,
            endScreen: CONST.TALK.END,
            nextScene: CONST.SCENES.SCHOOL,
            endButtons: {
                normalNoSkip: {x: 505, y: 411, scale: 1.25},
                normalWithSkip: {x: 362, y: 411, scale: 1.25},
                skip: {x: 649, y: 411, scale: 1.25}
            }
          })
    }
    _init(){
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.timer = 0;
        this.speed = 0;
        this.missedNoteCount = 0;
        this.notes = [];

        this.reachedEnd = false;
    }

    _preload(){
    }

    _create(){
        this.cameras.main.setBounds(0, 0, 8000, 480);

        this.add.image(6664, 240, CONST.TALK.ENDSTRETCH).setScale(578, 1);
        this.add.image(3449, 240, CONST.TALK.STRETCHBACKGROUND).setScale(33.148, 1);
        this.add.image(0, 0, CONST.TALK.STARTBACKGROUND).setOrigin(0, 0).setDepth(0);
        this.add.image(252, 89, CONST.TALK.TAP);
        this.add.image(5763, 240, CONST.TALK.ENDBACKGROUND);
        this.add.image(6091, 305, CONST.TALK.SMILE).setScale(0.15, 0.15).setAngle(9.6);

        this.createNotes();

        this.audio = this.sound.add(CONST.AUDIO.TALK, {
            loop: false
        });
    }

    onGameStarted = () =>{
        this.audio.play();
    }

    private createNotes(){
        this.notePositions.forEach(notePos => {
            var note = this.add.image(notePos.x, notePos.y, notePos.key)
                                .setScale(0.86, 0.86)
                                .setInteractive()
                                .setDepth(10);

            note.isAlive = true;

            note.on("pointerdown", () => {
                this.sound.play(CONST.AUDIO.POP, {detune: this.getDetune(), volume: 0.5});
                note.kill();
            });

            note.kill = () => {
                note.playDeathAnimation();
                note.isAlive = false;
            }

            note.update = (delta: number) => {
                if (note.isAlive){
                    note.checkBounds();
                }
            };

            note.checkBounds = () => {
                if (note.x < (this.cameras.main.scrollX - this.noteScrollOffset)){
                    //Note has been missed 
                    if (this.missedNoteCount < this.maxAllowedNoteMisses){
                        this.missedNoteCount ++;
                        note.kill();
                    } else {
                        this.triggerLoss();
                    }
                }
            }

            note.playDeathAnimation = () => {
                //Rotation
                this.tweens.timeline({
                    tweens: [{
                        targets: note,
                        angle: '-=14',
                        duration: 116,
                        ease: 'Sine.easeInOut',
                    },
                    {
                        targets: note,
                        angle: '+=180',
                        duration: 300,
                        ease: 'Sine.easeIn',
                    }]           
                });

                //Scale:
                this.tweens.timeline({
                    tweens: [{
                        targets: note,
                        scaleX: '*=1.5',
                        scaleY: '*=1.5',
                        duration: 116,
                        ease: 'Sine.easeInOut',
                    },
                    {
                        targets: note,
                        scaleX: 0,
                        scaleY: 0,
                        duration: 300,
                        ease: 'Sine.easeIn',
                    }]           
                });
            }

            this.notes.push(note);
        });
    }

    _update(time: number, delta: number){
        if (this.isCurrentState(CONST.GAMESTATE.START)) return;
        this.moveCamera(delta);
        if (!this.isCurrentState(CONST.GAMESTATE.PLAYING)) return;
        this.notes.forEach(note => {note.update(delta)});
    }

    private moveCamera(delta: number){
        if (this.reachedEnd) return;
        this.timer += delta / this.timeToReachMaxSpeed;
        this.speed = Phaser.Math.Interpolation.SmoothStep (this.timer, 0, this.maxSpeed);

        this.cameras.main.scrollX = this.cameras.main.scrollX + this.speed * delta/1000;
    }

    _timeout(){
        this.triggerWin();
    }

    _afterLoss(){
    }

    _afterWin(){
        this.audio.pause();
    }

    private triggerWin(){
        //trigger win after 1 second and load next scene
        this.reachedEnd = true;
        this.winGame(1000);
    }

    private triggerLoss(){
        this.audio.pause();
        this.loseGame(0);
    }
}